import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import * as MemberProfileStore from '@shared/store/member-profile';
import { UserLogout } from '@shared/store/user';

@Component({
  selector: 'ten-sso-rate-limitation',
  templateUrl: './sso-rate-limitation.component.html',
  styleUrls: ['./sso-rate-limitation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, MatButtonModule],
})
export class SsoRateLimitationComponent {
  constructor(private ngrxStore: Store<MemberProfileStore.MemberProfileState>) {}

  public logOut() {
    this.ngrxStore.dispatch(new UserLogout());
  }
}
